import { DropDownBox } from '@apply/components';
import { useCustomPaymentPurpose } from '../../../../../fields/CustomPaymentFields';
import { CustomPaymentPurposeTypeOptions } from '../../../../../constants/CustomPaymentPurposeTypeOptions';

interface PaymentPurposeProps {
    customPaymentId: string;
    onValueChange?: (value: string) => void;
}

export const PaymentPurpose: React.FC<PaymentPurposeProps> = ({ customPaymentId, onValueChange }) => {
    const label = 'Payment Purpose';
    const [paymentPurpose, set_paymentPurpose] = useCustomPaymentPurpose(customPaymentId);

    const paymentPurposeTypeValues = [
        { display: '', value: '' },
        ...CustomPaymentPurposeTypeOptions.map((st) => {
            return {
                display: st.display.toString(),
                value: st.value.toString(),
            };
        }),
    ];

    return (
        <>
            <DropDownBox
                id='paymentPurpose'
                value={paymentPurpose}
                onChange={(value) => set_paymentPurpose(value)}
                label={label}
                required={true}
                dataSource={paymentPurposeTypeValues}
                valueExpr='value'
                displayExpr='display'
            />
        </>
    );
};
